import {defineRouting} from 'next-intl/routing';
import {createNavigation} from 'next-intl/navigation';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'fr', 'ar'],

  // Used when no locale matches
  defaultLocale: 'en',

  localePrefix: 'never',

  pathnames :{
    "/": "/",
    "/blog":"/blog",
    "/padlev":"/padlev",
    "/livside":"/livside",
    "/padel-master-the-game":"/padel-master-the-game",
    "/blog/[id]":"/blog/[id]",
    "/industry":"/industry",
    "/maintenance-support":"/maintenance-support",
    "/testing-consulting":"/testing-consulting",
    "/web-seo":"/web-seo",
    "/ui-ux":"/ui-ux",
    "/business-professional":"/business-professional",
    "/Commerce-Hospitality":"/Commerce-Hospitality",
    "/Education-Public":"/Education-Public",
    "/Health-Lifestyle":"/Health-Lifestyle",
    "/Property-Construction":"/Property-Construction",
    "/Technology-Digital":"/Technology-Digital",
    "/studies":"/studies",
    "/about-us":"/about-us",
    "/login": "/login",
    "/trends":"/trends",
    "/contact-us":"/contact-us",
    "/auth/popup-success/": "/auth/popup-success/",
    "/account/report":"/account/report",
    "/account/balance":"/account/balance",
    "/account/billing":"/account/billing",
    "/account/payment":"/account/payment",
    "/pricing": "/pricing",
    "/cookies-policy":"/cookies-policy",
    "/account/offer": {
      en: "/account/offer",
      fr: "/compte/offer",
      ar: "/الحساب/العروض",
      nl: "/account/offers",
      de: "/konto/angebote",
      pt: "/conta/ofertas",
      sv: "/konto/erbjudanden",
      ru: "/аккаунт/предложения",
      it: "/account/offerte",
      es: "/cuenta/ofertas",
    },
    "/account": {
      en: "/account",
      fr: "/compte",
      ar: "/الحساب",
      nl: "/account",
      de: "/konto",
      pt: "/conta",
      sv: "/konto",
      ru: "/аккаунт",
      it: "/account",
      es: "/cuenta",
    },
    "/account/address": {
      en: "/account/address",
      fr: "/compte/adresse",
      ar: "/الحساب/العنوان",
      nl: "/account/adres",
      de: "/konto/adresse",
      pt: "/conta/endereco",
      sv: "/konto/adress",
      ru: "/аккаунт/адрес",
      it: "/account/indirizzo",
      es: "/cuenta/direccion",
    },
    "/privacy-policy": {
      en: "/privacy-policy",
      fr: "/politique-de-confidentialite",
      ar: "/سياسة-الخصوصية",
      nl: "/privacybeleid",
      de: "/datenschutz",
      pt: "/politica-de-privacidade",
      sv: "/integritetspolicy",
      ru: "/политика-конфиденциальности",
      it: "/politica-sulla-privacy",
      es: "/politica-de-privacidad",
    },

    "/login-signin": {
      en: "/login-signin",
      fr: "/connexion",
      ar: "/تسجيل-الدخول",
      nl: "/inloggen",
      de: "/anmelden",
      pt: "/entrar",
      sv: "/logga-in",
      ru: "/вход",
      it: "/accedi",
      es: "/iniciar-sesion",
    },
    "/reset-email": {
      en: "/reset-email",
      fr: "/reinitialiser-email",
      ar: "/إعادة-تعيين-البريد",
      nl: "/reset-email",
      de: "/email-zurücksetzen",
      pt: "/redefinir-email",
      sv: "/aterstall-e-post",
      ru: "/сброс-почты",
      it: "/reimposta-email",
      es: "/restablecer-correo",
    },
    "/reset-password": {
      en: "/reset-password",
      fr: "/reinitialiser-mot-de-passe",
      ar: "/إعادة-تعيين-كلمة-المرور",
      nl: "/reset-wachtwoord",
      de: "/passwort-zurücksetzen",
      pt: "/redefinir-senha",
      sv: "/aterstall-losenord",
      ru: "/сброс-пароля",
      it: "/reimposta-password",
      es: "/restablecer-contrasena",
    },
    "/terms-and-conditions": {
      en: "/terms-and-conditions",
      fr: "/conditions-generales",
      ar: "/الشروط-والأحكام",
      nl: "/algemene-voorwaarden",
      de: "/agb",
      pt: "/termos-e-condicoes",
      sv: "/villkor",
      ru: "/условия",
      it: "/termini-e-condizioni",
      es: "/terminos-y-condiciones",
    },
      "/refund-policy": {
      en: "/refund-policy",
      fr: "/politique-de-remboursement",
      ar: "/سياسة-الاسترداد",
      nl: "/terugbetalingsbeleid",
      de: "/rueckerstattungsrichtlinie", // or "/rückerstattungsrichtlinie"
      pt: "/politica-de-reembolso", // or "/política-de-reembolso"
      sv: "/aterbetalningspolicy", // or "/återbetalningspolicy"
      ru: "/politika-vozmeshcheniya", // or "/политика-возмещения"
      it: "/politica-di-rimborso",
      es: "/politica-de-reembolso", // or "/política-de-reembolso"
    }
    
   
  },
  
});


export type Locale = (typeof routing.locales)[number];
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);

export type AppPathname = keyof typeof routing.pathnames;
export type AppLocale = typeof routing.locales[number];

